import { useEffect } from 'react';
import { useStateValue } from './UseStateValue';
import { useConfigContext } from '../context/ConfigContext';
import { getGiftcard } from '../helpers/giftcard';

export const useGiftcard = () => {
    const [, dispatch] = useStateValue();
    const config = useConfigContext();

    useEffect(() => {
        getGiftcard({ config, dispatch });
    }, [config, dispatch]);
};
